import parse from 'url-parse';
import type { Avatar } from '../model/types.tsx';
import type { State } from './types.tsx';

export const getProjectId = (state: State): number => state.appProps.projectId;
export const getIsOpen = (state: State): boolean => state.appProps.isOpen;
export const getSelectedAvatar = (state: State): Avatar | undefined => {
	const avatar = state.appProps.selectedAvatar;
	if (avatar) {
		return {
			...avatar,
			uri: parse(avatar.uri).href,
		};
	}
	return avatar;
};
export const getOnAvatarSelected = (state: State): ((arg1: Avatar) => void) =>
	state.appProps.onAvatarSelected;
export const getOnDismiss = (state: State): (() => void) => state.appProps.onDismiss;

export const getAvatars = (state: State): Avatar[] => state.avatars;
export const getIsFetching = (state: State): boolean => state.isFetching;
export const getIsSaving = (state: State): boolean => state.isSaving;
export const getFetchError = (state: State): boolean => state.fetchError;
